import { useCompanyInfo } from "@/api/services/main/company";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { CompanyUserCreateContent } from "@/features/company/components/company-user/CompanyUserCreateContent";
import { useValidateId } from "@/hooks/useValidateId";
import { AppRoutes } from "@/routes/config";

const CompanyUserCreatePage = () => {
  const queryResult = useCompanyInfo();
  const { data, isLoading } = queryResult;
  useValidateId("companyId", AppRoutes.companyList, queryResult);

  if (!data || isLoading) return <LoadingPage />;

  return <CompanyUserCreateContent companyData={data.data} />;
};

export default CompanyUserCreatePage;
